<template>
  <a class="position-relative">

    <b-modal id="excel-reports-modal"
             size="sm"
             centered
             hide-footer
             :title="$t('exports')"
             @show="onShow"
             @hide="onHide">
      <div v-if="!reports.length && !loading" class="text-center">
        {{ $t('no_data_available') }}
      </div>
      <div class="list-group">
        <div v-for="report in reports"
             :key="`report-${report.id}`"
             @click="loadReport(report)"
             class="pointer gray-hover pr-3">
          <div class="row align-items-center">
            <div class="col">
              <div v-if="report.title">{{ report.title }}</div>
              <div class="small text-muted">
                {{ $t('export_from') }} {{ formatDateTime(report.created_at) }}
              </div>
              <div :class="{
              'text-success': report.status === 'finished',
              'text-muted': report.status === 'in_progress'
            }">
                {{ $t(reportStatus(report.status)) }}<span v-if="report.status === 'in_progress'">{{ '.'.repeat(dots) }}</span>
              </div>
            </div>
            <div class="col-auto" v-if="report.final_filename">
              <DownloadSvg class="svg-stroke-light svg-size-lg"/>
            </div>
          </div>

        </div>
      </div>

    </b-modal>

    <span @click="bvModal.show('excel-reports-modal')"
          class="pointer position-relative">
      <span class="notification-bubble"></span>
      <ExcelSvg class="user-svg svg-light"/>
    </span>
  </a>
</template>

<script setup>
import ExcelSvg from '@/assets/svg-vue/general/excel.svg'
import DownloadSvg from '@/assets/svg-vue/patients/upload.svg'
import { EloquentService } from "@/services/api/eloquent.api.service"
import { ref, provide, computed, onBeforeMount, getCurrentInstance } from "vue"
import { formatDateTime } from "@/extensions/filters/filters"
import JwtService from "@/services/jwt.service"
import { useStore } from "vuex"

const store = useStore()

const reports = ref([])
const dots = ref(1)
let bvModal = null
let timer

const clinic = computed(() => store.state.auth.clinic)
const superadmin = computed(() => store.state.auth.superadmin)
const loading = computed(() => store.state.dom.loading)

const getReports = async () => {
  try {
    const res = await EloquentService.dataTable('excel_in_progress', 1, {
      pagination: 999,
      order: 'id',
      sort: 'desc',
    })
    reports.value = res.data.result.data
  } catch (e) {
    reports.value = []
  }
}

const loadReport = (report) => {
  if(!report.final_filename) {
    return
  }
  const link = JwtService.getPrintPrelink(clinic.value, superadmin.value)
  location.href = link+'/excel/'+report.final_filename
}

const reportStatus = (status) => {
  if(status === 'finished') return 'ready'
  return status
}

const onShow = () => {
  getReports()
  timer = setInterval(() => {
    dots.value = (dots.value % 3) + 1
  }, 300)
}

const onHide = () => {
  if(timer) {
    clearInterval(timer)
    timer = null
  }
}

onBeforeMount(() => {
  const instance = (getCurrentInstance())
  bvModal = instance?.proxy?.$bvModal
})

provide('reloadExcelReports', getReports)
</script>

<style>
.notification-bubble {
  top: 2px;
  left: 12px;
}
</style>
